import { transport } from 'config/transport';

export function callApiCreateThuDauNam(gradeId, body) {
    return transport.post(`/mamnon/thuhocsinh/thudaunam`, body, { params: { gradeId } });
}
